import ClaimsActivityDashboardContextProvider, { ClaimsActivityDashboardContext } from "@app/projects/network-assessment/pci-dashboard/claims-activity/ClaimsActivityDashboardContext";
import { ClaimsActivityDashboardDefaultView } from "@app/projects/network-assessment/pci-dashboard/claims-activity/ClaimsActivityDashboardDefaultView";
import { ClaimsActivityDashboardScenarioView } from "@app/projects/network-assessment/pci-dashboard/claims-activity/ClaimsActivityDashboardScenarioView";
import ClaimsActivityDownloadGhostProviders from "@app/projects/network-assessment/pci-dashboard/claims-activity/ClaimsActivityDownloadGhostProviders";
import PciDashboardFilters from "@app/projects/network-assessment/pci-dashboard/shared/PciDashboardFilters";
import PciDashboardFiltersContextProvider, { PciDashboardFiltersContext } from "@app/projects/network-assessment/pci-dashboard/shared/PciDashboardFiltersContext";
import PciDashboardWrapper from "@app/projects/network-assessment/pci-dashboard/shared/PciDashboardWrapper";
import React, { FC, useContext } from "react";

export const WrappedClaimsActivity: React.FC<React.PropsWithChildren<unknown>> = () => {
  const claimsActivityContext = useContext(ClaimsActivityDashboardContext);
  const pciDashboardFiltersContext = useContext(PciDashboardFiltersContext);

  return (
    <PciDashboardWrapper
      showLineOfBusiness={true}
    >
      <div className="row">
        <div className="col-12">
          <ClaimsActivityDownloadGhostProviders />
        </div>
      </div>
      <PciDashboardFilters
        isLoading={
          claimsActivityContext.networkProvidersSummariesLoading ||
          claimsActivityContext.marketProvidersSummariesLoading ||
          claimsActivityContext.prospectProvidersSummariesLoading ||
          claimsActivityContext.topGhostProviderCountiesLoading ||
          claimsActivityContext.topGhostProviderSpecialtiesLoading
        }
        isPca={true}
        onApplyFiltersClick={claimsActivityContext.onApplyFiltersClick}
        showLineOfBusiness={true}
      />
      {pciDashboardFiltersContext?.displayedFilters?.compareTimeslices ? (
        <ClaimsActivityDashboardScenarioView />
      ) : (
        <ClaimsActivityDashboardDefaultView />
      )}
    </PciDashboardWrapper>
  );
}

const ClaimsActivity: FC = () => (
  <PciDashboardFiltersContextProvider>
    <ClaimsActivityDashboardContextProvider>
      <WrappedClaimsActivity />
    </ClaimsActivityDashboardContextProvider>
  </PciDashboardFiltersContextProvider>
);

export default ClaimsActivity;
